<span class="d-none">{{ version }}</span>